import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';
import { testListPageStyles } from '../Tests.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useMyResultsStyles = makeStyles(() => ({
  ...testListPageStyles,
  page: {
    ...testListPageStyles.page,
    overflowAnchor: 'none',
  },
  headerContent: {
    marginTop: spacing.xs,
    maxWidth: 688,
  },
  stats: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      gap: 29,
      width: 'auto',
      flexShrink: 0,
      paddingTop: spacing.md,
    },
  },
  // Figma 1051:15426 — vertical 72px separators between stats
  statDivider: {
    width: 1,
    alignSelf: 'stretch',
    backgroundColor: colors.brownDark,
    flexShrink: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      alignSelf: 'auto',
      height: 72,
    },
  },
  statItem: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: spacing.sm,
    color: colors.brownDark,
    textAlign: 'center',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flex: '0 0 auto',
      alignItems: 'flex-end',
      gap: 20,
      minWidth: 110,
      padding: 0,
      textAlign: 'right',
    },
  },
  statValue: {
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.xxl,
    lineHeight: 1.6,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      fontSize: 40,
      lineHeight: 1,
    },
  },
  statLabel: {
    fontFamily: fonts.gothic,
    fontSize: fontSize.xs,
    letterSpacing: 0.9,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      fontSize: fontSize.md,
      letterSpacing: 1.26,
    },
  },
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
  },
  tableScroll: {
    width: '100%',
    overflowX: 'auto',
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
  },
  table: {
    width: '100%',
    minWidth: 980,
    borderCollapse: 'collapse',
    fontFamily: fonts.opensans,
  },
  resultRow: {
    scrollMarginTop: 88,
    scrollMarginBottom: 88,
  },
  tableHead: {
    backgroundColor: colors.tableHeader,
  },
  tableHeaderCell: {
    height: 56,
    padding: '0 16px',
    textAlign: 'left',
    borderBottom: `1px solid ${colors.border}`,
    color: colors.text,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.md,
    lineHeight: 'normal',
  },
  tableDateCell: {
    width: 220,
    padding: '12px 16px',
    borderBottom: `1px solid ${colors.border}`,
    verticalAlign: 'middle',
  },
  tableTestCell: {
    padding: '12px 16px',
    borderBottom: `1px solid ${colors.border}`,
    color: colors.text,
    fontSize: fontSize.base,
    lineHeight: 1.4,
    letterSpacing: 0.32,
  },
  tableHeaderActionCell: {
    textAlign: 'left',
  },
  tableActionCell: {
    width: 680,
    padding: '12px 16px',
    borderBottom: `1px solid ${colors.border}`,
    textAlign: 'left',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  dateValue: {
    color: colors.text,
    fontSize: fontSize.md,
    lineHeight: 'normal',
  },
  timeValue: {
    color: '#838183',
    fontSize: fontSize.md,
    lineHeight: 'normal',
  },
  primaryButton: {
    ...primaryButtonStyle,
    whiteSpace: 'nowrap',
  },
  secondaryButton: {
    ...secondaryButtonStyle,
    color: colors.text,
    whiteSpace: 'nowrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: spacing.sm,
    flexWrap: 'nowrap',
  },
  buttonIcon: {
    width: 16,
    height: 16,
  },
  smallLoader: {
    width: '16px !important',
    height: '16px !important',
    color: 'inherit',
  },
  mobileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  resultCard: {
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
    scrollMarginTop: 88,
    scrollMarginBottom: 88,
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: spacing.sm,
  },
  cardTitle: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 1.4,
    letterSpacing: 0.32,
  },
  cardMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    color: colors.text,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 'normal',
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: `${spacing.xs}px ${spacing.sm}px ${spacing.sm}px`,
  },
  cardActionsMinor: {
    gap: 12,
  },
  cardActionsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  mobileDownloadButton: {
    flex: 1,
    minWidth: 0,
    padding: '0 16px',
  },
  mobileRetakeButton: {
    flexShrink: 0,
    padding: '0 16px',
  },
  mobileFullWidthButton: {
    width: '100%',
  },
  mobilePrimaryButton: {
    width: '100%',
  },
  pdfContainer: {
    display: 'block',
    position: 'absolute',
    top: '-2000%',
    left: 0,
    zIndex: 0,
  },
}));
